import React from 'react';
import { Router, Switch, Route } from 'react-router-dom';
import { createBrowserHistory } from 'history';

import config from '../helpers/config';
import AddEstimateLoader from '../components/AddEstimateLoaderConnector';
import LoadEstimateLoader from '../components/LoadEstimateLoaderConnector';
import DesignSummaryList from '../components/DesignSummaryListConnector';
import SessionLoader from '../components/SessionLoaderConnector';
import FallbackLoader from '../components/FallbackLoaderConnector';
import SavedProductDesignLoader from '../components/SavedProductDesignConnector';

export const history = createBrowserHistory({ basename: '/' });

export default () => (
  <Router history={history}>
    <React.Fragment>
      <Switch>
        <Route path={`${config.estimatebuilderBasePath}/:sessionId([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})`} component={SessionLoader} />
        <Route path={`${config.estimatebuilderBasePath}/new`} component={AddEstimateLoader} />
        <Route path={`${config.estimatebuilderBasePath}${config.estimatebuilderLoadPath}/:designIds`} component={LoadEstimateLoader} />
        <Route path={`${config.estimatebuilderBasePath}${config.estimatebuilderSummaryPath}/:designIds`} component={DesignSummaryList} />
        <Route path={`${config.estimatebuilderBasePath}/loadSavedProductDesign/:designId`} component={SavedProductDesignLoader} />

        <Route path={config.estimatebuilderBasePath} component={FallbackLoader} />
      </Switch>
    </React.Fragment>
  </Router>
);
